import { Injectable } from '@angular/core';
import {
  CalculateStrategyModel,
  EditableParam,
  PreparationModel
} from '@core/models/quotation-calculate';
import { QuotationDTO, QuotationParamsDTO } from '@core/modules/api/models';
import { firstPositiveNumber } from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class QuotationCalculateHookService {
  constructor() {}

  getUpdateParams(options: {
    actualQuotation: QuotationDTO;
    entries: PreparationModel;
    strategy: CalculateStrategyModel;
    editingParam?: EditableParam;
  }): QuotationParamsDTO {
    const params: QuotationParamsDTO = {
      id: options.actualQuotation.tuplaId,
      tan: options.actualQuotation.tan,
      amount:
        options.entries.amount ||
        options.actualQuotation.netDisbursedAmountToCustomer
    };

    if (options.strategy === 'amount-duration') {
      params.duration = firstPositiveNumber(
        options.entries.duration,
        options.actualQuotation.duration
      );
    } else {
      params.installment = firstPositiveNumber(
        options.entries.installment,
        options.actualQuotation.installment
      );
    }

    if (options.entries.finality || options.actualQuotation.finality) {
      params.finality =
        options.entries.finality || options.actualQuotation.finality;
    }

    if (options.actualQuotation.financialTable) {
      params.financialTable = options.actualQuotation.financialTable;
    }

    if (options.actualQuotation.correspondenceSendingMethod) {
      params.communicationsModality =
        options.actualQuotation.correspondenceSendingMethod;
    }

    params.constraints = {
      tanMin: options.actualQuotation.tan,
      tanMax: options.actualQuotation.tan
    };

    return params;
  }
}
